module.exports = __webpack_public_path__ + "static/media/login-logo.d09a2b7a.png";